import { ROLE_NAME } from '@dashboard/library';

export enum TABLE_COLUMN_ID {
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  SUPERVISOR = 'supervisor',
  ADMIN = 'admin',
  OWNER = 'owner',
}

export const TABLE_COLUMNS = {
  [TABLE_COLUMN_ID.EMAIL]: 'bulk_user_creation.prepare_file.example_table.columns.email',
  [TABLE_COLUMN_ID.FIRST_NAME]: 'bulk_user_creation.prepare_file.example_table.columns.first_name',
  [TABLE_COLUMN_ID.LAST_NAME]: 'bulk_user_creation.prepare_file.example_table.columns.last_name',
  [TABLE_COLUMN_ID.SUPERVISOR]: 'bulk_user_creation.prepare_file.example_table.columns.supervisor',
  [TABLE_COLUMN_ID.ADMIN]: 'bulk_user_creation.prepare_file.example_table.columns.admin',
  [TABLE_COLUMN_ID.OWNER]: 'bulk_user_creation.prepare_file.example_table.columns.owner',
};

export const SAMPLE_TABLE_SORTED_ROLES: string[] = [
  ROLE_NAME.SUPERVISOR,
  ROLE_NAME.ADMIN,
  ROLE_NAME.OWNER,
  // Agent role is not present in the CSV but should always be at the end of the roles input
  ROLE_NAME.AGENT,
];

export const BULK_USERS_CSV_TEMPLATE_FILENAME = 'aircall_users_template.csv';
